import { useEffect, useState } from 'react';
import axios from 'axios';
import { API_URL } from '../config/api';

const Analytics = () => {
  const [analyticsLoaded, setAnalyticsLoaded] = useState(false);

  useEffect(() => {
    const loadAnalytics = async () => {
      try {
        const response = await axios.get(`${API_URL}/settings`);
        const settings = response.data;
        
        // Load Google Analytics 4
        if (settings.google_analytics_id) {
          loadGoogleAnalytics(settings.google_analytics_id);
        }
        
        // Load Plausible
        if (settings.plausible_domain) {
          loadPlausible(settings.plausible_domain);
        }
        
        setAnalyticsLoaded(true);
      } catch (error) {
        console.error('Failed to load analytics settings:', error);
      }
    };

    loadAnalytics();
  }, []);

  const loadGoogleAnalytics = (measurementId) => {
    // Check if already loaded
    if (window.gtag) return;
    
    // Load gtag.js
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    document.head.appendChild(script);
    
    // Initialize gtag
    window.dataLayer = window.dataLayer || [];
    window.gtag = function() {
      window.dataLayer.push(arguments);
    };
    window.gtag('js', new Date());
    window.gtag('config', measurementId, {
      page_title: document.title,
      page_location: window.location.href,
    });
    
    console.log('Google Analytics loaded:', measurementId);
  };

  const loadPlausible = (domain) => {
    // Check if already loaded
    if (document.querySelector('script[data-domain]')) return;
    
    const script = document.createElement('script');
    script.defer = true;
    script.setAttribute('data-domain', domain);
    script.src = 'https://plausible.io/js/script.js';
    document.head.appendChild(script);
    
    console.log('Plausible Analytics loaded:', domain);
  };

  return null; // This component doesn't render anything
};

// Track custom events
export const trackEvent = (eventName, eventParams = {}) => {
  // Google Analytics
  if (window.gtag) {
    window.gtag('event', eventName, eventParams);
  }
  
  // Plausible
  if (window.plausible) {
    window.plausible(eventName, { props: eventParams });
  }
};

// Track contact form submission
export const trackContactFormSubmission = (service) => {
  trackEvent('contact_form_submission', {
    event_category: 'engagement',
    event_label: service,
    service_type: service,
  });
};

// Track page view (useful for SPA navigation)
export const trackPageView = (pagePath, pageTitle) => {
  // Google Analytics
  if (window.gtag) {
    window.gtag('event', 'page_view', {
      page_path: pagePath,
      page_title: pageTitle,
    });
  }
  
  // Plausible tracks automatically, but we can send custom pageview
  if (window.plausible) {
    window.plausible('pageview', { u: pagePath });
  }
};

export default Analytics;
